import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { getTitle } from '@dashboard/ui';
import { Subscription } from 'rxjs';
import { DashboardPagesConfiguration } from './shared';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <app-feedback [text]="'auth.feedback.actions.feedback' | translate"></app-feedback>
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription = new Subscription();

  constructor(private readonly router: Router, private readonly title: Title) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.updatePageTitle(event.url);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private updatePageTitle(url: string): void {
    const customTitle = DashboardPagesConfiguration.CustomPageTitles[url];
    const titleToSet = customTitle ?? `${getTitle()} Dashboard`;
    this.title.setTitle(titleToSet);
  }
}
